import ListingCard from './ListingCard';
import EditButton from './DashboardListingCard/components/buttons/EditButton';

export default function DashboardListings({listings, openInNewTab}) {
  return (
    <div className="card-row">
      {_.map(listings, (listing) => (
        <div key={listing.id} className="card-column">
          <ListingCard contributor listing={listing}/>
          <div className="row">
            <EditButton listingId={listing.id} primaryClass width="full" openInNewTab={openInNewTab}/>
          </div>
        </div>
      ))}
    </div>
  );
}
